import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { TextAreaDialogData } from '@app/shared/models/dialog-data';
import { ConfirmModalComponent } from '@app/shared/dialogs/confirm-dialog/confirm-modal.component';

@Component({
  selector: 'app-text-area-dialog',
  templateUrl: './text-area-dialog.component.html',
  styleUrls: ['./text-area-dialog.component.scss']
})
export class TextAreaDialogComponent extends ConfirmModalComponent implements OnInit {

  public textAreaText: string;

  constructor(public dialogRef: MatDialogRef<TextAreaDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: TextAreaDialogData) {
    super(dialogRef, data);
    this._idPrefix = 'textarea_dialog.';
  }

  public ngOnInit() {
  }

  public accept(): void {
    this.dialogRef.close({ text: this.textAreaText });
  }
}
